/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomerApiService } from './customer-api.service';

@Injectable({
  providedIn: 'root',
})
export class ChatApiService {
  constructor(private api: CustomerApiService) {}

  getChats(): Observable<any> {
    return this.api.get('/v1/chats');
  }

  getChatDetails(chatId: string): Observable<any> {
    return this.api.get(`/v1/chats/${chatId}`);
  }

  startNewChat(title: string): Observable<any> {
    return this.api.get('/v1/chats/start', { title });
  }

  postChatConversation(
    chatId: string,
    actor: string,
    message: string,
  ): Observable<any> {
    return this.api.post(`/v1/chats/${chatId}/message`, { actor, message });
  }

  deleteChat(chatId: string): Observable<any> {
    return this.api.delete(`/v1/chats/${chatId}`);
  }

  editChatTitle(chatTitle: string, chatId: string): Observable<any> {
    return this.api.post(
      `/v1/chats/${chatId}/title?title=${encodeURIComponent(chatTitle)}`,
      {},
    );
  }

  postChatFeedback(
    chatId: string,
    messageId: string,
    feedback: string,
  ): Observable<any> {
    return this.api.post(
      `/v1/chats/feedback?chat_id=${chatId}&message_id=${messageId}&feedback_type=${feedback}`,
      {},
    );
  }

  deleteChatFeedback(chatId: string, messageId: string): Observable<any> {
    return this.api.delete(
      `/v1/chats/feedback?chat_id=${chatId}&message_id=${messageId}`,
    );
  }
}
